import React from "react";
import { useSelector } from "react-redux";
import { ROLES } from "../../utils/roles";
import { RootState } from "../../../redux/store/store";

type Props = {
    children: React.ReactNode;
};

const AdminOnly: React.FC<Props> = ({ children }) => {
    const { userRole, authReady } = useSelector(
        (state: RootState) => state.auth
    );

    const isAdmin = authReady && userRole === ROLES.A12_B;

    // Esperamos a que auth esté lista (evita flashes)
    if (!authReady) return null;

    // No admin → no render
    if (!isAdmin) return null;

    return <>{children}</>;
};

export default AdminOnly;
